// extracted by mini-css-extract-plugin
export default {"stores-container":"ProductsPage_stores-container__MNG4G","products-container":"ProductsPage_products-container__MK3OH"};